<div class="partner-attribution-container container" fxLayout="column" fxLayoutAlign="start end">
  <ng-content></ng-content>
</div>
